import { ButtonDesktop as Button } from '@tui-react/button';
import cn from 'classnames';
import React, { ReactElement } from 'react';
import useRootElement from '../../hooks/useRootElement';
import { inIframe } from '../../utils/location';
import Markdown from '../Markdown';
import { NewPage } from '../NewPage';
import { WebviewCloseButton } from '../WebviewCloseButton';
import styles from './NewOverlay.module.css';

interface NewOverlayProps {
  isLoading?: boolean;
  title: string | ReactElement;
  icon: React.ReactNode;
  description: React.ReactNode;
  buttonText?: string;
  onClick?: VoidFunction;
  onClose: VoidFunction;
  ctaButton?: {
    text: string;
    href: string;
  };
  isWebview?: boolean;
  alignContent?: 'center' | 'left';
}

const HIDE_IMAGE_HEIGHT = 360;

export const NewOverlay: React.FC<NewOverlayProps> = ({
  icon,
  title,
  description,
  buttonText,
  onClick,
  onClose,
  isLoading,
  isWebview,
  ctaButton,
  alignContent,
}) => {
  const { element } = useRootElement();

  return (
    <div id="content">
      <NewPage
        className={cn(styles.layout, {
          [c(styles.withBorder)]: inIframe(),
          [c(styles.alignLeft)]: alignContent === 'left',
        })}
      >
        {element.clientHeight >= HIDE_IMAGE_HEIGHT && icon}

        <div className={cn(styles.errorBody, { [c(styles.alignLeftText)]: alignContent === 'left' })}>
          <h2 className={styles.title}>
            {React.isValidElement(title) ? title : <Markdown>{title as string}</Markdown>}
          </h2>
          <p className={styles.description}>
            {React.isValidElement(description) ? description : <Markdown>{description as string}</Markdown>}
          </p>
        </div>

        {ctaButton ? (
          <div className={styles.button}>
            <Button href={ctaButton.href} size="m" loading={isLoading} target="_blank" rel="noopener noreferrer">
              {ctaButton.text}
            </Button>
          </div>
        ) : (
          !!buttonText &&
          !!onClick && (
            <div className={styles.button}>
              <Button size="m" loading={isLoading} {...(!isLoading && { onClick })}>
                {buttonText}
              </Button>
            </div>
          )
        )}

        {isWebview && <WebviewCloseButton className={styles.closeButton} onClick={onClose} />}
      </NewPage>
    </div>
  );
};
